export default __webpack_public_path__ + "static/logos-4a58998db6559b52d9f630fc03c97f92.png";